// 별도 창(채팅·파일)의 세션 키 — 순수 함수만 둔다(단위 시험이 `node --test` 로 바로 불러 쓴다).

/**
 * 세션 키 — 창 label 에 들어가므로 **영숫자·하이픈만**(Rust `popup_window.rs` `valid_key` 와 같은 규칙).
 * @param prefix 종류 표시 한 글자(채팅 `c` · 파일 `f`) — 로그에서 어느 창인지 보이게
 */
export function newPopupKey(prefix: string): string {
  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}${Date.now().toString(36)}-${rand}`;
}
